import { Box } from "../atoms";
import { styled } from "utils";

const Page = styled(Box);

export { Page };
